module.exports = __webpack_public_path__ + "img/safety.360aa304.svg";